import { useLocation } from 'react-router-dom';
import SignupFormProvider from '@jetshop/core/components/Auth/SignupFormContainer';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import React, { useEffect } from 'react';
import { styled } from 'linaria/react';
import { Redirect } from 'react-router';
import BaseMaxWidth from '../../Layout/MaxWidth';
import LoadingPage from '../../LoadingPage';
import Address from './Address';
import LoginFields from './LoginFields';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import { Intl } from '@jetshop/intl';
import Head from '@jetshop/core/components/Head';
import { DynamicContentRenderer } from '../../ContentEditor/DynamicContentRenderer';
import { theme } from '../../Theme';
import t from 'format-message';
import { Link } from 'react-router-dom';
import { ClubAccessField } from './ClubAccessField';
const MaxWidth = styled(BaseMaxWidth)`
  align-items: center;

  p {
    line-height: 1.5;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }

  button {
    width: 100%;
    max-width: 100%;
  }

  .hint {
    margin-top: 0.5rem;
    font-style: italic;
    font-size: 0.75rem;
    text-align: center;
  }

  .section {
    margin-bottom: 2rem;
    transition: opacity 0.6s ease;
  }

  .section-column-row {
    display: flex;
    align-items: flex-start;
    grid-gap: 40px;
    margin-top: 30px;
    ${theme.below.lg} {
      display: block;
    }
    .section-column {
      flex: 1;
    }
  }
`;

const TextLink = styled(Link)`
  text-decoration: none;
  color: ${theme.colors.blue};
  text-align: right;
  font-size: 0.875em;
  :hover {
    opacity: 0.8;
  }
  &.login-link {
    margin-left: auto;
  }
`;

function formatSignupInput(values) {
  const dynamicContent = JSON.stringify({
    ...values.dynamicContent,
    created: Date.now().toString()
  });
  console.log({ ...values, dynamicContent });
  return { ...values, dynamicContent };
}

function SignUpPage() {
  const { loggedIn } = useAuth();
  const { routes } = useShopConfig();
  const location = useLocation();
  let redirect = routes.myPages.path;
  if (location?.search?.indexOf('redirect=') > -1) {
    redirect = location.search.split('redirect=')[1];
  }

  let preselectedClub = location?.search?.split('club=')?.[1] ?? '';

  if (loggedIn) {
    return <Redirect to={redirect} />;
  }

  return (
    <SignupFormProvider
      LoadingComponent={<LoadingPage />}
      additionalFormatter={formatSignupInput}
      additionalInitialValues={{
        dynamicContent: {
          club: '',
          club_code: preselectedClub
        },
        preferences: {
          type: {
            acceptsEmail: true,
            acceptsSms: true
          }
        }
      }}
    >
      <DynamicContentRenderer categoryId={2060} />
      <MaxWidth style={{ marginTop: '2em' }}>
        <Intl>{t => <Head data={{ title: t('Signup') }} />}</Intl>
        <section>
          <div className="section-column-row">
            <div className="section-column">
              <Address />
            </div>
            <div className="section-column">
              <ClubAccessField preselected={!!preselectedClub} />
              <LoginFields />
            </div>
          </div>
        </section>

        <div>
          <TextLink
            to={routes.login.path + '?redirect=' + redirect}
            className="login-link"
          >
            {t('Already a member? Sign In')}
          </TextLink>
        </div>
      </MaxWidth>
    </SignupFormProvider>
  );
}

export default SignUpPage;
